import React from 'react';
import { TechPageHeaderVariant } from 'src/features/common/tech-pages/tech-pages.types';
import { StyledTechPageHeader } from 'src/features/white-labels/ocean/tech-pages/components/tech-pages.styles';
import { Typography } from 'src/ui/common/atoms/typography';
import { PageLayout } from 'src/ui/common/layouts/page-layout';

interface IProperties {
    title: string;
    subtitle: string;
    type?: TechPageHeaderVariant;
}

export const TechPageHeader: React.VFC<IProperties> = ({ title, subtitle, type = 'monochrome' }) => (
    <StyledTechPageHeader type={type}>
        <PageLayout fullWidth={false}>
            <Typography tag="h1" variant="title" size="2xl" semiBold={type === 'faq'}>
                {title}
            </Typography>
            <Typography tag="p" variant="text" size="xs">
                {subtitle}
            </Typography>
        </PageLayout>
    </StyledTechPageHeader>
);
